module.exports = __webpack_public_path__ + "static/img/home_bottom_05.4b60008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_bottom_05.jpg
// module id = KXof
// module chunks = 1